import { NumberInput } from "@mantine/core";
import React from "react";
import { withTranslation } from "react-i18next";

const NumberInputField = ({
  label,
  value,
  disabled,
  icon,
  placeholder,
  onChange,
  form,
  validateName,
  required,
  onBlur,
  onInput,
  min,
  max,
}) => {
  return (
    <NumberInput
      label={label}
      onChange={onChange}
      min={min}
      max={max}
      onInput={onInput}
      icon={
        icon && (
          <img
            src={require(`../../assets/${icon}.svg`)}
            style={{ width: "18px", height: "18px", margin: "2px 7px" }}
            alt="icon"
          />
        )
      }
      defaultValue={value}
      onBlur={onBlur}
      disabled={disabled}
      required={required}
      placeholder={placeholder}
      {...form?.getInputProps(validateName)}
      styles={{
        input: {
          border: "1px solid rgb(0,0,0,0.2)",
        },
      }}
    />
  );
};

export default withTranslation()(NumberInputField);
